<section class="container">
  <div class="row">
    <div class="col-md-8 text-md-right mb-4 mb-md-0">
      <a
        class="c-link"
        [routerLink]="['/my-account/orders']"
        href="javascript: void(0);"
      >
        <fa-icon [icon]="faChevronLeft" class="icon"></fa-icon>
        {{ 'orderDetail.backToOrder' | cxTranslate }}
      </a>
    </div>
    <div
      class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-right d-flex flex-wrap gap-1 justify-content-md-end"
    >
      <ng-template #popSaveTitle>{{
        'orderDetail.orderName' | cxTranslate
        }}</ng-template>
      <ng-template #popSaveContent>
        <input
          type="text"
          class="save-order"
          [(ngModel)]="saveCartName"
          maxlength="30"
          (keypress)="omitSpecialChar($event)"
        />
        <span class="float-none common-error">{{ errorMsg }}</span>
        <div class="c-popover">
          <!-- Cancel Button -->
          <button
            type="reset"
            class="popover-close popover-cancel-button c-button c-button--secondary"
            (click)="toggle(p1)">
            {{ 'orderDetail.cancel' | cxTranslate }}
          </button>
          <!-- Save Button -->
          <button
            class="popover-cancel-button c-button c-button--primary"
            type="submit"
            data-di-id="di-id-3064f17d-e97cc628"
            (click)="saveOrder()">
            {{ 'orderDetail.save' | cxTranslate }}
          </button>
        </div>
      </ng-template>
      <a
        class="c-link"
        [ngbPopover]="popSaveContent"
        [popoverTitle]="popSaveTitle"
        triggers="manual"
        #p1="ngbPopover"
        placement="top"
        (click)="toggle(p1)"
        container="body"
        popoverClass="popover-links order-detail-save"
      >
        <span>{{ 'orderDetail.saveOrder' | cxTranslate }}</span>
        <fa-icon [icon]="faRectangleList" class="icon"></fa-icon>
      </a>
      <a (click)="excelDownload()" class="c-link">
        <span>{{ 'orderDetail.xls' | cxTranslate }}</span>
        <fa-icon [icon]="faFileExcel" class="icon"></fa-icon>
      </a>
      <a (click)="print()" class="c-link">
        <span>{{ 'orderDetail.print' | cxTranslate }}</span>
        <fa-icon [icon]="faPrint" class="icon"></fa-icon>
      </a>
    </div>
  </div>
</section>

<section class="container mb-4">
  <!-- Mobile Only Order Total -->
  <div class="row mb-4 mt-4">
    <section
      class="col-md-12 py-4 u-border-top-grey d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row d-block d-sm-none"
    >
      <h3 class="font-bold mb-0">
        {{ 'orderDetail.orderTotal' | cxTranslate }}
        <br><span class="text-fixed-medium">{{ 'orderDetail.orderTotalsIncPostSecondPart' | cxTranslate }}</span>
      </h3>
      <h1 class="font-bold mb-0">
        {{ orderDetailsData?.totalPriceWithTax?.formattedValue }}
      </h1>
    </section>
  </div>
  <!-- Main content -->
  <div class="row text-fixed-medium">
    <div class="col-md-8 u-border-right-grey pr-md-4 pr-lg-5">
      <div class="row pb-4 u-border-bottom-grey">
        <div class="col-md-6 mb-4">
          <em class="fa fa-map-marker-alt font-n"></em>
          <span class="px-3 text-fixed-medium">
            {{ orderDetailsData?.deliveryAddress?.companyName }}
            {{ '(' + orderDetailsData?.shippingAddress?.cnpjNumber + ')' }}
          </span>
        </div>
        <div class="col-md-6">
          <p class="mb-2">
            <span class="font-bold">
              {{ 'orderDetail.order' | cxTranslate }}
            </span>
            <span>{{ orderDetailsData?.guid }}</span>
          </p>
          <p class="m-0">
            <span class="font-bold">{{
              'orderDetail.orderDate' | cxTranslate
            }}</span
            >&nbsp;
            <span>{{ orderDetailsData?.created | date: "dd/MM/yyyy" }}</span>
          </p>
        </div>
      </div>
      <!-- Contract -->
      <div class="row py-4 u-border-bottom-grey" *ngIf="orderDetailsData?.contractId">
        <div class="col-md-12">
          <em class="fa fa-clipboard font-n"></em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.orderDetailsData?.contractId}} ({{this.orderDetailsData?.contractName}})
        </div>
      </div>
      <!-- Order Status -->
      <div class="row pt-4 pb-md-4 u-border-bottom-grey">
        <div class="col-md-4">
          <h3 class="font-bold">
            {{ 'orderDetail.orderStatus' | cxTranslate }}
          </h3>
          <p
            class="m-md-0"
            *ngIf="
              orderDetailsData?.statusDisplay !== undefined &&
              orderDetailsData?.statusDisplay !== ''
            "
          >
            {{ orderDetailsData?.statusDisplay }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              orderDetailsData?.statusDisplay === undefined ||
              orderDetailsData?.statusDisplay === ''
            "
          ></p>
        </div>
        <div class="col-md-4">
          <h3 class="font-bold">{{ 'orderDetail.placedBy' | cxTranslate }}</h3>
          <p class="m-md-0" *ngIf="(orderDetailsData?.placedBy !== undefined ||
            orderDetailsData?.placedBy !== '') && (orderDetailsData?.user?.name !== undefined ||
            orderDetailsData?.user?.name !== '')">
            {{ orderDetailsData?.user?.name }}
          </p>
          <p class="m-md-0" *ngIf="orderDetailsData?.placedBy &&  (orderDetailsData?.placedBy != null ||
              orderDetailsData?.placedBy != '')">
            ({{ 'orderDetail.by' | cxTranslate }} {{ orderDetailsData?.placedBy }})
          </p>

          <p
            class="m-md-0"
            *ngIf="
              (orderDetailsData?.placedBy == undefined ||
              orderDetailsData?.placedBy == '') && (orderDetailsData?.user?.name === undefined ||
              orderDetailsData?.user?.name === '')
            "
          >
            -
          </p>
        </div>
        <div class="col-md-4">
          <h3 class="font-bold">
            {{ 'orderDetail.po' | cxTranslate }}
          </h3>
          <p
            class="m-md-0"
            *ngIf="
              orderDetailsData?.purchaseOrderNumber !== undefined &&
              orderDetailsData?.purchaseOrderNumber !== ''
            "
          >
            {{ orderDetailsData?.purchaseOrderNumber }}
          </p>
          <p
            class="m-md-0"
            *ngIf="
              orderDetailsData?.purchaseOrderNumber === undefined ||
              orderDetailsData?.purchaseOrderNumber === ''
            "
          >
            -
          </p>
        </div>
      </div>
      <!-- Billing -->
      <div class="row row pt-4 pb-4 u-border-bottom-grey">
        <div class="col-md-12 mb-4">
          <h2 class="font-bold">{{ 'orderDetail.billing' | cxTranslate }}</h2>
        </div>
        <div class="col-md-6">
          <h3 class="font-bold">{{ 'orderDetail.billTo' | cxTranslate }}</h3>
          <p class="mb-1">
            {{ 'orderDetail.accountCnpj' | cxTranslate
            }} {{ orderDetailsData?.billingAddress?.cnpjNumber }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.billingAddress?.companyName }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.billingAddress?.line1 }},
            {{ orderDetailsData?.billingAddress?.line2 }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.billingAddress?.town }},
            {{ orderDetailsData?.billingAddress?.region?.isocodeShort }},
            {{ orderDetailsData?.billingAddress?.postalCode }}
          </p>
        </div>
        <div class="col-md-6 mt-4 mt-md-0">
          <div class="row mb-2">
            <div class="col-6">
              {{ 'orderDetail.orderSubtotal' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              {{ orderDetailsData?.subTotal?.formattedValue }}
            </div>
          </div>
          <div
            class="row pb-2 u-border-bottom-grey"
            *ngIf="
              orderDetailsData?.totalTax?.value !== 0 &&
              orderDetailsData?.totalTax?.value !== undefined
            "
          >
            <div class="col-6">
              {{ 'orderDetail.salesTax' | cxTranslate }}
            </div>
            <div class="col-6 text-right">
              ${{ orderDetailsData?.totalTax?.value | number : '1.2-2' }}
            </div>
          </div>
          <div class="row mt-2 font-bold">
            <div class="col-6">
              {{ 'orderDetail.orderTotalsIncPost' | cxTranslate }}
              <br><span class="text-fixed-medium">{{ 'orderDetail.orderTotalsIncPostSecondPart' | cxTranslate }}</span>
            </div>
            <div class="col-6 text-right">
              {{ orderDetailsData?.totalPrice?.formattedValue }}
            </div>
          </div>
        </div>
      </div>
      <!-- Shipping -->
      <div class="row row pt-4 pb-4 u-border-bottom-grey">
        <div class="col-md-12 mb-4">
          <h2 class="font-bold">
            {{ 'orderDetail.shippingMethod' | cxTranslate }}
          </h2>
        </div>
        <div class="col-md-6">
          <h3 class="font-bold">{{ 'orderDetail.shipTo' | cxTranslate }}</h3>
          <p class="mb-1">
            {{ 'orderDetail.accountCnpj' | cxTranslate
            }} {{ orderDetailsData?.deliveryAddress?.cnpjNumber }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.deliveryAddress?.companyName }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.deliveryAddress?.line1 }},
            {{ orderDetailsData?.deliveryAddress?.line2 }}
          </p>
          <p class="mb-1">
            {{ orderDetailsData?.deliveryAddress?.town }},
            {{ orderDetailsData?.deliveryAddress?.region?.isocodeShort }},
            {{ orderDetailsData?.deliveryAddress?.postalCode }}
          </p>
        </div>
      </div>
      <section
        class="row py-4 mt-2 mt-md-0"
        *ngFor="let productEntry of orderDetailsData?.entries"
      >
        <!-- image -->
        <div class="col-md-2 mb-4">
          <a
            class="in-active"
            (click)="openProductDetails(productEntry)"
            title="{{ productEntry?.product?.name }}"
          >
            <img
              class="prod-Image"
              *ngIf="productEntry?.PRIMARY !== undefined; else undefinedImg"
              src="{{ productEntry?.PRIMARY?.url }}"
              alt="Product Image"
            />
            <ng-template #undefinedImg>
              <img
                class="prod-Image"
                [src]="fallbackImage"
                alt="Product Image"
              />
            </ng-template>
          </a>
        </div>
        <!-- details -->
        <div class="col-md-10">
          <a
            class="c-link mb-1"
            title="{{ productEntry?.product?.name }}"
            (click)="openProductDetails(productEntry)"
          >
            <span
              [innerHTML]="getProductName(productEntry?.product?.name)"
            ></span>
          </a>
          <p
            class="mb-1"
            [innerHtml]="getDescription(productEntry?.product?.description)"
          ></p>
          <p class="mb-1">
            <span class="font-bold">{{
              'orderDetail.productNumber' | cxTranslate
            }}</span>
            {{ productEntry?.product?.sapEan }}
          </p>
        </div>
        <!-- table -->
        <div class="col-md-12">
          <table
            class="c-table c-table--branded c-table--small d-none d-lg-table"
          >
            <thead>
              <tr>
                <th scope="col">
                  {{ 'orderDetail.status' | cxTranslate }}
                </th>
                @if (orderDetailsData?.contractId) {
                  <th scope="col">
                    {{ 'orderDetail.requestedQuantity' | cxTranslate }}
                  </th>
                }
                <th scope="col">
                  {{ 'orderDetail.totalUnits' | cxTranslate }}
                </th>
                <th scope="col">
                  {{ 'orderDetail.confirmed' | cxTranslate }}{{
                    'orderDetail.shippedUnits' | cxTranslate
                  }}
                </th>
                <th scope="col" class="text-center">
                  <!-- BIVV -->
                  <span *ngIf="productEntry?.product?.actualPotency">{{
                    'orderDetail.iuPrice' | cxTranslate
                  }}</span>
                  <!--GenMed -->
                  <span *ngIf="!productEntry?.product?.actualPotency">
                    {{'orderDetail.yourPrice' | cxTranslate}}
                    <span *ngIf="productEntry?.unit =='UNT'" >(un)</span>
                    <span *ngIf="productEntry?.unit =='NGU'" >(menor un)</span>
                  </span>
                </th>
                <th scope="col" class="text-center">
                  {{ 'orderDetail.subtotal' | cxTranslate }}
                </th>
              </tr>
            </thead>
            <tbody
              class="datatable-row"
              *ngIf="productEntry?.prodConsignments?.length === 1"
            >
              <tr
                class="text-center"
                *ngFor="
                  let data of productEntry?.prodConsignments;
                  let i = index
                "
              >
                <td>{{ productEntry?.quantityStatus }}</td>
                @if (orderDetailsData?.contractId) {
                  <td>{{ productEntry?.requestedQuantity || '\\' }}</td>
                }
                <td>{{ productEntry?.quantity }}</td>
                <td class="extra-width text-center">
                  {{ data?.entries[0]?.shippedQuantity }}
                </td>
                <td>
                  {{ productEntry?.basePrice?.value | localCurrency }}
                </td>
                <td>
                  {{ productEntry?.totalPrice?.value | localCurrency }}
                </td>
              </tr>
            </tbody>
            <tbody
              class="datatable-row"
              *ngIf="productEntry?.prodConsignments?.length > 1"
            >
              <tr
                class="text-center"
                *ngFor="
                  let data of productEntry?.prodConsignments;
                  let i = index
                "
              >
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="productEntry?.prodConsignments?.length"
                >
                  {{ productEntry?.quantityStatus }}
                </td>
                @if (i === 0) {
                  <td [attr.rowspan]="productEntry?.prodConsignments?.length ?? 1">
                    {{ !!productEntry?.requestedQuantity ? productEntry.requestedQuantity : '\\' }}

                  </td>
                }
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="productEntry?.prodConsignments?.length"
                >
                  {{ productEntry?.quantity }}
                </td>
                <td>
                  {{ data?.entries[0]?.shippedQuantity }}
                </td>
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="productEntry?.prodConsignments?.length"
                >
                  {{ productEntry?.basePrice?.value | localCurrency }}
                </td>
                <td
                  *ngIf="i === 0"
                  [attr.rowspan]="productEntry?.prodConsignments?.length"
                >
                  {{ productEntry?.totalPrice?.value | localCurrency }}
                </td>
              </tr>
            </tbody>
            <tbody
              class="datatable-row"
              *ngIf="
                productEntry?.prodConsignments === undefined ||
                productEntry?.prodConsignments?.length === 0
              "
            >
              <tr class="details-col text-center">
                <td>{{ productEntry?.quantityStatus }}</td>
                @if (orderDetailsData?.contractId) {
                  <td>{{ productEntry?.requestedQuantity || '\\' }}</td>
                }
                <td>{{ productEntry?.quantity }}</td>
                <td>
                  {{ productEntry?.confirmedQuantity }}
                </td>
                <td>
                  {{ productEntry?.basePrice?.value | localCurrency }}
                </td>
                <td>
                  {{ productEntry?.totalPrice?.value | localCurrency }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- mobile table -->
          <table
            class="c-table c-table--branded c-table--branded--two-col d-table d-lg-none"
            *ngIf="productEntry?.prodConsignments?.length > 0"
          >
            <tr
              class="commonViewTable"
              *ngFor="let data of productEntry?.prodConsignments; let i = index"
            >
              <td class="header">{{ 'orderDetail.status' | cxTranslate }}</td>
              <td>{{ productEntry?.quantityStatus }}</td>

              @if (orderDetailsData?.contractId) {
                <td class="header">
                  {{ 'orderDetail.requestedQuantity' | cxTranslate }}
                </td>
                <td>{{ productEntry?.requestedQuantity || '\\' }}</td>
              }


              <td class="header">
                {{ 'orderDetail.totalUnits' | cxTranslate }}
              </td>
              <td>{{ productEntry?.quantity }}</td>

              <p>
                <label
                  >{{ 'orderDetail.confirmed' | cxTranslate }}
                  {{ 'orderDetail.shippedUnits' | cxTranslate }}</label
                >
                <span>{{ data?.entries[0]?.shippedQuantity }}</span>
              </p>
              <p>
                <label>{{ 'orderDetail.yourPrice' | cxTranslate }}</label>
                <span>{{ item?.basePrice?.value | localCurrency }}</span>
              </p>
              <p>
                <label>{{ 'orderDetail.subtotal' | cxTranslate }}</label>
                <span>{{ item?.totalPrice?.value | localCurrency }}</span>
              </p>
            </tr>
          </table>
          <table
            class="c-table c-table--branded c-table--branded--two-col d-table d-lg-none"
            *ngIf="
              productEntry?.prodConsignments === undefined ||
              productEntry?.prodConsignments?.length === 0
            "
          >
            <tr>
              <td class="header">{{ 'orderDetail.status' | cxTranslate }}</td>
              <td>{{ productEntry?.quantityStatus }}</td>

              @if (orderDetailsData?.contractId) {
                <td class="header">
                  {{ 'orderDetail.requestedQuantity' | cxTranslate }}
                </td>
                <td>{{ productEntry?.requestedQuantity || '\\' }}</td>
              }

              <td class="header">
                {{ 'orderDetail.totalUnits' | cxTranslate }}
              </td>
              <td>{{ productEntry?.quantity }}</td>

              <td class="header">
                {{ 'orderDetail.confirmed' | cxTranslate }}
                {{ 'orderDetail.shippedUnits' | cxTranslate }}
              </td>
              <td>{{ productEntry?.confirmedQuantity }}</td>

              <td class="header">
                {{ 'orderDetail.yourPrice' | cxTranslate }}
                <span *ngIf="productEntry?.unit =='UNT'" >(un)</span>
                <span *ngIf="productEntry?.unit =='NGU'" >(menor un)</span>
              </td>
              <td>{{ productEntry?.basePrice?.value | localCurrency }}</td>

              <td class="header">
                {{ 'orderDetail.subtotal' | cxTranslate }}
              </td>
              <td>{{ productEntry?.totalPrice?.value | localCurrency }}</td>
            </tr>
          </table>
        </div>
      </section>
    </div>
    <!-- Sidebar -->
    <div class="col-md-4 pl-md-4 pl-lg-5">
      <section class="row">
        <section
          class="col-md-12 py-4 u-border-top-grey u-border-bottom-grey d-flex align-items-center justify-content-center justify-content-md-between flex-column flex-md-row"
        >
          <h3 class="font-bold mb-0">
            {{ 'orderDetail.orderTotalsIncPost' | cxTranslate }}
            <br><span class="text-fixed-medium">{{ 'orderDetail.orderTotalsIncPostSecondPart' | cxTranslate }}</span>
          </h3>
          <h1 class="font-bold mb-0">
            {{ orderDetailsData?.totalPriceWithTax?.formattedValue }}
          </h1>
        </section>
      </section>

      <section *ngIf="slobChecked">
        <br />
        {{ 'addToCartItems.slobDisclaimer' | cxTranslate }}
      </section>
    </div>
  </div>
</section>
